/**
 * Wrapper for DateRankPicker to support a 508-compliant calendar with
 * quantities/availabilities
 */

import React from 'react';
import PropTypes from 'prop-types';
import 'react-dates/initialize';

import DateRangePicker from './DateRangePicker';

import {
    renderDayWithQuantity,
    renderCalendarDayWithQuantity
} from './DayContentComponents';

export default class DateRangePickerWithQuantities extends React.PureComponent {
    static propTypes = {
        /** Function that takes a moment as a parameter and returns a number */
        getQuantity: PropTypes.func.isRequired,

        /** Function that takes a moment as a parameter and returns the content
         * of the tooltip */
        getTooltipContent: PropTypes.func
    };

    render() {
        const { getQuantity, getTooltipContent, ...rest } = this.props;

        return (
            <DateRangePicker
                {...rest}
                renderDayContents={renderDayWithQuantity(getQuantity)}
                renderCalendarDay={renderCalendarDayWithQuantity(getQuantity, getTooltipContent)}
                calendarInfoPosition="bottom" />
        );
    }
}